import { QuizCategory } from "src/data/models/quiz/QuizCategoryModel";

export const QuizCategoryLabel: { [key in QuizCategory]: string } = {
    [QuizCategory.ALL]: 'All Categories',
    [QuizCategory.SER_VS_ESTAR]: 'Ser vs Estar',
    [QuizCategory.POR_VS_PARA]: 'Por vs Para',
    [QuizCategory.PRESENT]: 'Present Tense',
    [QuizCategory.PAST_TENSE]: 'Past Tense',
    [QuizCategory.FUTURE_TENSE]: 'Future Tense',
    [QuizCategory.CONDITIONAL]: 'Conditional',
    [QuizCategory.IMPERATIVE]: 'Imperative',
    [QuizCategory.SUBJUNCTIVE]: 'Subjunctive',
    [QuizCategory.PREPOSITIONS]: 'Prepositions',
    [QuizCategory.PRONUNCIATION]: 'Pronunciation',
    [QuizCategory.VERBOS_REFLEXIVOS]: 'Reflexive Verbs',
    [QuizCategory.IDIOMATIC_EXPRESSIONS]: 'Idiomatic Expressions',
    [QuizCategory.PRONOUNS]: 'Pronouns',
    [QuizCategory.VOZ_ACTIVA_PASIVA]: 'Voice Active/Passive',
    [QuizCategory.DISCOURSE_CONNECTORS]: 'Discourse Connectors',
};